<template>
    <b-modal 
        id="modal-Equipment"
        :no-close-on-backdrop="true" 
        title="Create New Equipment" 
        hide-footer 
        centered 
        v-model="open"
        ref="modal-add-equipment">
        <b-form class="pb-20">
            <b-row >
                <b-col md="6" >
                    <gofix-form-input label="tag" v-model="equipment.tag_name"></gofix-form-input>
                </b-col>
                <b-col md="6" >
                    <gofix-form-tree
                        label="Equipment Group"
                        :options="groups"
                        :load-options="loadOptionsGroup"
                        placeholder=""
                        v-model="objTemp.group"
                        :normalizer="normalizerGroup"
                        search-nested
                        valueFormat="object">
                    </gofix-form-tree>
                </b-col>
            </b-row>
            <gofix-form-properties
                valueFormat="object"
                label="Location"
                :contract-id="$route.params.id"
                v-model="objTemp.location">
            </gofix-form-properties>

            <!-- desc='To create new brand, click "MORE"' -->
            <gofix-form-dropdown
                label="Brand"
                vLabel="name"
                :filterable="false"
                @search="searchEquipmentBrand"
                v-model="objTemp.brand"
                :options="brands">
                <template slot="gofixInput:dropdown:option" slot-scope="option">
                    <span class="color-000">{{ option.name }}</span>
                </template>
                <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                    <span class="color-000">{{ option.name }}</span>
                </template>
            </gofix-form-dropdown>

            <!-- desc='To create new model, click "MORE"' -->
            <gofix-form-dropdown
                label="Model"
                vLabel="name"
                :filterable="false"
                :disabled="!objTemp.brand"
                @search="searchEquipmentModel"
                v-model="objTemp.model"
                :options="models">
                <template slot="gofixInput:dropdown:option" slot-scope="option">
                    <span class="color-000">{{ option.name }}</span>
                </template>
                <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                    <span class="color-000">{{ option.name }}</span>
                </template>
            </gofix-form-dropdown>
            <gofix-form-input label="Serial Number" v-model="equipment.serial_number"></gofix-form-input>
        </b-form>

        <b-button-group class="d-block text-right">
            <gofix-button label="MORE" @click="moreItem" noBorder dark></gofix-button>
            <gofix-button label="APPLY" @click="save" :disabled="$disabledCreateOrUpdate(this.equipment, $accessModule.equipment)" noBorder></gofix-button>
        </b-button-group>
    </b-modal>
</template>
<script>
import {LOAD_CHILDREN_OPTIONS} from "@riophae/vue-treeselect";

const simulateAsyncOperation = fn => {
  setTimeout(fn, 500);
};
export default {
  name: 'modal-add-equipment',
  components: {},
  props: {
    value: {
      required: false,
      default: null
    },
    treeSelected: {
      type: Object,
      required: false,
      default: {
        groups: null,
        location: null
      }
    }
  },
  data() {
    return {
      open: this.value,
      loading: false,
      groups: [],
      brands: [],
      models: [],
      timer: {
        brand: null,
        model: null
      },
      objTemp: {
        group: null,
        brand: null,
        model: null,
        location: null
      },
      equipment: {
        tag_name: null,
        equipment_type: null,
        equipment_group_id: null,
        brand: null,
        brand_id: null,
        model: null,
        model_id: null,
        location: null,
        location_id: null,
        serial_number: null,
        is_active: true,
        custom_fields: [],
        contract_id: this.$route.params.id,
      },
    };
  },
  watch: {
    value: function (val) {
      this.open = val;
    },
    open: function (val) {
      this.$emit("input", val);
      if (val) {
        this.objTemp = {
          group: this.treeSelected && this.treeSelected.groups ? this.treeSelected.groups : null,
          brand: null,
          model: null,
          location: this.treeSelected && this.treeSelected.location ? this.treeSelected.location : null,
        };
        this.equipment = {
          tag_name: null,
          equipment_type: null,
          equipment_group_id: null,
          brand: null,
          brand_id: null,
          model: null,
          model_id: null,
          location: null,
          location_id: null,
          serial_number: null,
          is_active: true,
          custom_fields: [],
          contract_id: this.$route.params.id,
        };

        this.getEquipmentBrand();
        this.getEquipmentModel();
      }
    },
    "objTemp.group": function (val) {
      this.equipment.equipment_type = null;
      this.equipment.equipment_group_id = null;
      if (val && val.id) {
        this.equipment.equipment_type = val.name;
        this.equipment.equipment_group_id = val.id;
        this.getCustomFields(val.id);
      }
    },
    "objTemp.brand": function (val) {
      this.models = [];
      this.objTemp.model = null;
      this.equipment.brand = null;
      this.equipment.brand_id = null;
      if (val) {
        this.equipment.brand = val.name ? val.name : null;
        this.equipment.brand_id = val.id ? val.id : null;
        if(val.id) {
          this.getEquipmentModel();
        }
      }
    },
    "objTemp.model": function (val) {
      this.equipment.model = null;
      this.equipment.model_id = null;
      if (val) {
        this.equipment.model = val.name ? val.name : null;
        this.equipment.model_id = val.id ? val.id : null;
      }
    },
    "objTemp.location": function (val) {
      this.equipment.location = null;
      this.equipment.location_id = null;
      if (val && val.id) {
        this.equipment.location = val.name;
        this.equipment.location_id = val.id;
      }
    }
  },
  created() {
    this.getEquipmentGroups();
  },
  methods: {
    moreItem() {
      this.$store.commit('EquipmentV2Controller/setEquipment', JSON.parse(JSON.stringify(this.equipment)));
      return this.$router.push(`/v2/contract-client/${this.$route.params.id}/equipment/add`);
    },
    save() {
      if (!this.equipment.tag_name) {
        return this.$alertNotification('Tag name is a required field.', 'danger');
      }

      if (!this.equipment.equipment_group_id) {
        return this.$alertNotification('Equipment group is a required field.', 'danger');
      }

      if (!this.equipment.location_id) {
        return this.$alertNotification('Loacation is a required field.', 'danger');
      }

      this.$store.dispatch('EquipmentV2Controller/createEquipment', {
        equipment: this.equipment,
        //filter: this.pages.filter
      })
          .then(result => {
            this.open = false;
            this.$alertNotification(this.$notificationV2('adding', 'equipment'));
            this.$emit('addSuccess');
          })
          .catch(err => {
            console.log(err)
            this.$alertNotification(err.response.data.error.message.error, "danger");
          })
    },
    /*--- Equipment Group ---*/
    normalizerGroup(node) {
      if (node.isBatch)
        return {
          id: node.id,
          label: node.name,
          children: node.children,
        };
      return {
        id: node.id,
        label: node.name,
        children: undefined,
      };
    },
    loadOptionsGroup({action, parentNode, callback}) {
      if (action === LOAD_CHILDREN_OPTIONS) {
        if (parentNode.children) {
          parentNode.children = parentNode.children;
          callback();
          return;
        }
        if (parentNode.isBatch) {
          this.$store.dispatch("EquipmentV2Controller/getEquipmentCategory", {
            id: parentNode.data.id,
            contract_id: this.$route.params.id
          })
              .then(response => {
                simulateAsyncOperation(() => {
                  parentNode.children = response.data.data;
                  callback();
                });
              });
        } else {
          parentNode.children = [];
          callback();
        }
      }
    },
    getEquipmentGroups() {
      this.$store.dispatch("EquipmentV2Controller/getEquipmentCategory", {
        id: 0,
        contract_id: this.$route.params.id
      })
          .then(response => {
            this.groups = response.data.data;
          });
    },
    /*--- Equipment Brand ---*/
    async getEquipmentBrand(search = '') {
      await this.$store.dispatch("MasterBrandController/getItems", {
        limit: 100,
        sortColumn: "name",
        sortDirection: "ASC",
        filter: {
          name: search,
          contract_id: this.$route.params.id,
        }
      })
          .then(response => {
            this.brands = response.items;
            if (!this.brands.length && search) {
              this.objTemp.brand = {id: 0, name: search};
            }
          });
    },
    searchEquipmentBrand(search, loading) {
      loading(true);
      this.brands = []
      if (this.timer.brand) {
        clearTimeout(this.timer.brand);
        this.timer.brand = null;
      }
      this.timer.brand = setTimeout(async () => {
        try {
          await this.getEquipmentBrand(search);
          await loading(false);
        } catch (err) {
          loading(false);
        }
      }, 300);
    },
    /*--- Equipment Model ---*/
    async getEquipmentModel(search = '') {
      if (!this.equipment.brand_id) {
        if(search) this.objTemp.model = {id: 0, name: search, type_brand_id: this.equipment.brand_id};
        return;
      }

      await global.axios(`api/equipment/models`, {
        method: "GET",
        params: {
          type_brand_id: this.equipment.brand_id,
          search: search
        },
        headers: {
          Accept: "application/json"
        }
      })
          .then(response => {
            this.models = response.data.data;
            if (!this.models.length && search) {
              this.objTemp.model = {id: 0, name: search, type_brand_id: this.equipment.brand_id};
            }
          })
          .catch(error => {
            console.log(error);
          });
    },
    searchEquipmentModel(search, loading) {
      loading(true);
      this.equipmentModel = []
      if (this.timer.model) {
        clearTimeout(this.timer.brand);
        this.timer.model = null;
      }
      this.timer.model = setTimeout(async () => {
        try {
          await this.getEquipmentModel(search);
          await loading(false);
        } catch (err) {
          loading(false);
        }
      }, 300);
    },
    /*--- Custom Fields ---*/
    getCustomFields(equipment_group_id) {
      this.equipment.custom_fields = [];
      this.$store.dispatch('EquipmentV2Controller/getCustomFields', {
        equipment_group_id: equipment_group_id,
      })
          .then(response => {
            this.equipment.custom_fields = response;
          })
          .catch(err => {
            console.log(err);
          })
    }
  }
}
</script>
